import { createStore } from 'vuex'

import Layout from '@/view/home/Index'
import { router, routes } from '@/router'
import {getRouterList} from "@/apis/auth";

function generaMenu (routers, data) {
    data.forEach((item) => {
        let menu = {
            path: item.url,
            component: !item.file ? Layout : () => import(`@/view${item.file}`),
            hidden: true,
            children: [],
            name: item.name,
            meta: {title: item.title, icon: item.icon, id: item.id}
        }
        routers.push(menu)
        if (item.Childrens) {
            let children = item.Childrens;
            children.forEach((items) => {
                let menuChildren = {
                    path: items.url,
                    component: () => import(`@/view${items.file}`),
                    hidden: true,
                    children: [],
                    name: items.name,
                    meta: {title: items.title, icon: items.icon, id: items.id}
                }
                routers.push(menuChildren)
            })
        }
    })
}
const state = {
    tableHight : '',
    token : window.localStorage.getItem('token'),//登录token
    userinfo : window.localStorage.getItem('userinfo') && window.localStorage.getItem('userinfo') !== 'undefined' ? JSON.parse(window.localStorage.getItem('userinfo')) : '' ,
    nav_id : 1 ,
    open_names : 1 ,
    active_names : 1 ,
    routers: routes,
    addRouters: [],
    auth : '',
    parentRouterName : ''
}

const mutations = {
    SET_OPEN_NAMES(state , data){
        state.open_names = data;
        localStorage.setItem('open_names', data);
    },
    SET_ACTIVE_NAMES(state , data){
        state.active_names = data;
        localStorage.setItem('active_names', data);
    },
    //设置路由父名称
    SET_PARENT_ROUTER_NAME(state , data){
        state.parentRouterName = data;
    },
    //设置自适应高度
    SET_TABLE_HEIGHT(state , data){
        state.tableHight = data;
    },
    //设置token
    SET_TOKEN(state , data){
        state.token = data;
        localStorage.setItem('token', data);
    },
    //设置用户信息
    SET_USERINFO(state , data){
        state.userinfo = data;
        localStorage.setItem('userinfo', JSON.stringify(data));
    },
    //设置路由信息
    SET_ROUTERS(state, routers){
        state.addRouters = routers
        state.routers = routes.concat(routers)
        //这里将动态组装的路由添加到路由里面
        for(let x of state.routers){
            router.addRoute(x)
        }
    },
    //路由权限
    SET_AUTH(state , data){
        state.auth = data;
        localStorage.setItem('auth', data);
    },
    //全局Loading
    SET_LOADING(state , data){
        state.loading = data;
    }
}

const getters = {
    token(state){
        return state.token
    },
    addRouters(){
        return state.addRouters
    }
}

const actions = {
    GetUserInfo () {
        return new Promise(() => {

        })
    },
    GenerateRoutes ({ commit }) {
        return new Promise(resolve => {
            // 获取缓存中的菜单信息
            if (state.auth) {
                let routers = []
                generaMenu(routers,  JSON.parse(state.auth))
                let unfound = { path: '/404', redirect: '/404', hidden: true }
                routers.push(unfound)
                commit('SET_ROUTERS', routers)
                resolve()
            } else {
                getRouterList().then( e =>{
                    let routers = [];
                    commit('SET_ROUTERS', routers)
                    commit('SET_AUTH', JSON.stringify(e.data))
                    resolve()
                })
            }
        })
    }
}

export const store = createStore({
    state,mutations,getters,actions
})